var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-banner-detail',{staticClass:"pt-banner-detail__page",attrs:{"position":_vm.position,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }